import { addModalEventListeners } from './modalEventListeners.js';
import { toggleElements } from './searchModalUtils.js';


const handleModalAdded = (node, elementsToHide) => {
    if (node.classList && node.classList.contains('csh-aem-base-header__search-modal')) {
        addModalEventListeners(node, elementsToHide);
    }
}

const observeModalAdditions = (elementsToHide) => {
    return new MutationObserver((mutationsList) => {
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => handleModalAdded(node, elementsToHide));
            }
        });
    });
}

const handleSearchButtonClick = (elementsToHide) => {
    toggleElements(elementsToHide, 'hide');
    const modal = document.querySelector('.csh-aem-base-header__search-modal');
    if (modal) {
        addModalEventListeners(modal, elementsToHide);
    } else {
        const modalObserver = observeModalAdditions(elementsToHide);
        modalObserver.observe(document.body, { childList: true, subtree: true });
    }
}

const handleDocumentClick = (event, searchButton, elementsToHide) => {
    const modal = document.querySelector('.csh-aem-base-header__search-modal');
    if (modal && !modal.contains(event.target) && !searchButton.contains(event.target)) {
        if (modal.classList.contains('show')) {
            toggleElements(elementsToHide, 'show');
        }
    }
}

const addSearchButtonEventListener = (searchButton, elementsToHide) => {
    searchButton.addEventListener('click', () => handleSearchButtonClick(elementsToHide));
    document.addEventListener('click', (event) => handleDocumentClick(event, searchButton, elementsToHide));
}

    export { addSearchButtonEventListener };

